import React from "react";
import {
  Flex,
} from "@chakra-ui/react";
import Forums from "./components/Forums"
const Data = () => {
  return (
    <Flex direction="column" pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <Forums />
    </Flex>
  );
}

export default Data;
